import * as React from "react"
const Barcode = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#202327"
      d="M7.56 2.438h.067c.325 0 .623 0 .865.032.266.036.548.12.78.352.232.232.316.513.352.78.032.242.032.54.032.864V13.534c0 .324 0 .622-.032.864-.036.267-.12.548-.352.78-.232.232-.514.316-.78.352-.242.033-.54.033-.865.033H7.56c-.324 0-.622 0-.864-.033-.267-.036-.549-.12-.78-.352-.232-.232-.316-.514-.352-.78a6.964 6.964 0 0 1-.033-.864V4.466c0-.324 0-.622.033-.864.036-.267.12-.548.352-.78.231-.232.513-.316.78-.352.242-.033.54-.033.864-.033Z"
    />
    <path
      fill="#202327"
      fillRule="evenodd"
      d="M1.594 2.438a.74.74 0 0 1 .75.729v11.666a.74.74 0 0 1-.75.73.74.74 0 0 1-.75-.73V3.167a.74.74 0 0 1 .75-.73ZM3.844 2.438a.74.74 0 0 1 .75.729v11.666a.74.74 0 0 1-.75.73.74.74 0 0 1-.75-.73V3.167a.74.74 0 0 1 .75-.73ZM11.344 2.438a.74.74 0 0 1 .75.729v11.666a.74.74 0 0 1-.75.73.74.74 0 0 1-.75-.73V3.167a.74.74 0 0 1 .75-.73Z"
      clipRule="evenodd"
    />
    <path
      fill="#202327"
      d="M15.06 2.438h.067c.325 0 .623 0 .865.032.266.036.548.12.78.352.232.232.316.513.352.78.032.242.032.54.032.864V13.534c0 .324 0 .622-.032.864-.036.267-.12.548-.352.78-.232.232-.514.316-.78.352-.242.033-.54.033-.865.033h-.067c-.324 0-.622 0-.864-.033-.267-.036-.549-.12-.78-.352-.232-.232-.316-.514-.352-.78a6.963 6.963 0 0 1-.033-.864V4.466c0-.324 0-.622.033-.864.036-.267.12-.548.352-.78.231-.232.513-.316.78-.352.242-.033.54-.033.864-.033Z"
    />
  </svg>
)
export default Barcode
